import { render, staticRenderFns } from "./ResumeLanguages.vue?vue&type=template&id=297a04aa&"
import script from "./ResumeLanguages.vue?vue&type=script&lang=js&"
export * from "./ResumeLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports